import { Component, OnInit, AfterViewInit, OnDestroy,  ViewChild } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ActivatedRoute, Router } from '@angular/router';
import { IAccount } from "../headerandnavigation/accounts/account";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/Subject";
import { ManagedCardService } from "./managecards.service";
import { LiveCard, StopCard, StopCardModel, LiveCardModel, LiveStopCardModel } from "./managecards";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { ApiEndPoints } from "../api.endpoints";
import { LoaderService } from "../LoaderService";

declare var $: any;

@Component({
  templateUrl: "./managedcards.stopcards.component.html"
})
export class StopCardsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  public pageTitle: string = 'Manage Cards';
  public managedCardsName: string = 'stopcards';
  public stopCardsList: LiveCard[];
  public selectedStopCardsList: StopCard[] = [];
  public accessAccounts: IAccount[];
  constructor(
    private authService: AuthService,
    private appCommonService: AppCommonService,
    public managedCardService: ManagedCardService,
    private route: ActivatedRoute,
    private router: Router,
    public headerAndNavigationService: HeaderAndNavigationService,
    public loaderService: LoaderService
  ) {
    this.appCommonService.pageContentAdditionalClass = "";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit(): void {
    this.headerAndNavigationService.showhideNav(false, true);
    this.accessAccounts = this.authService.getSelectedAccessAccounts();
    
    this.loadStopCardsList();
  }
  ngAfterViewInit(): void {
    const selfme = this;
    $('#modal-stopcards').on('hidden.bs.modal', function () {      
      selfme.managedCardService.msgs = [];
      selfme.selectedStopCardsList = [];
      var table = $('#stopcardspopupdatatable').DataTable();
      table.destroy();
    });

    $.extend($.fn.dataTableExt.oSort, {
      "non-empty-string-asc": function (str1, str2) {
        if (str1 == null || str1 == "")
          return 1;
        if (str2 == null || str2 == "")
          return -1;
        return ((str1 < str2) ? -1 : ((str1 > str2) ? 1 : 0));
      },

      "non-empty-string-desc": function (str1, str2) {
        if (str1 == null || str1 == "")
          return 1;
        if (str2 == null || str2 == "")
          return -1;
        return ((str1 < str2) ? 1 : ((str1 > str2) ? -1 : 0));
      }
    });
  }

  loadStopCardsList() {
    this.loaderService.display(true);
    var model: LiveStopCardModel = new LiveStopCardModel();
    model.AccountNumbers = [];
    model.Token = this.authService.getToken().access_token;
    //model.EndPointURL = ApiEndPoints.LiveCardsEndPoint;
    //model.PendingStopEndPointURL = ApiEndPoints.PendingStopCardsEndPoint;
    let user = this.authService.getUser();
    //overwritten on 08-01-2020 as userId was returning null
    let userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternalLocalhost")));
    if (userData == undefined) {
      userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternal")));
    }
    if (userData != null) {
      model.UserId = userData.sub;
    }
    this.accessAccounts.forEach(item => {
      model.AccountNumbers.push(item.name);
    });
    this.managedCardService.getStopCards(model)
      .subscribe(
      (livecards: LiveCard[]) => {
        this.stopCardsList = livecards;
        setTimeout(() => {
          this.afterloaddata();
          this.loaderService.display(false);
        }, 100);
      },
      (error: any) => {
        this.loaderService.display(false);
        this.managedCardService.showError("Stop Cards retrieval problem", <any>error);
      }
    );
  }

  afterloaddata() {
    const self = this;
    $('#stopcardsdatatable').DataTable({
      //dom: "fltB<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
      dom: '<"top"fipB<"clear">>rt<"bottom"ipB<"clear">>',
      responsive: true,
      info: false,
      iDisplayLength: 15,
      order: [],
      columnDefs: [{ targets: [0], width: 32, searchable: false }, { orderable: false, targets: [0] }, { "type": "non-empty-string", targets: [4, 5] }],
      fixedColumns: true,
      buttons: [
        {
          text: '<button class="btn custom bgBlue stopcardsBtn"  style="padding: 0; width: auto; height: auto; "  id="stopcardsBtn" data-toggle="modal">Stop Cards</button >'
        }
      ]
    });

    //Check All Functionality
    $('#stopcardsdatatable thead th input[type=checkbox]').change(function () {
      var set = $("#stopcardsdatatable tbody tr input[type=checkbox]");
      var checked = $(this).is(":checked");
      $(set).each(function () {
        if (checked) {
          $(this).prop("checked", true);
          $(this).parents('tr').addClass("active");
        } else {
          $(this).prop("checked", false);
          $(this).parents('tr').removeClass("active");
        }
      });      
    });
    $('#stopcardsdatatable tbody tr input[type=checkbox]').change(function () {
      $(this).parents('tr').toggleClass("active");
    });

    $('.stopcardsBtn').click(function () {
      self.getSelectedStopCards();
    });

    // DataTable
    var table = $('#stopcardsdatatable').DataTable();
    
    // Apply the search
    table.columns().every(function () {
      var that = this;

      $('input', this.footer()).on('keyup change', function () {
        if (that.search() !== this.value) {
          that
            .search(this.value)
            .draw();
        }
      });
    });
  }

  getSelectedStopCards() {    
    this.loaderService.display(true);
    const selfme = this;
    var table = $('#stopcardsdatatable').DataTable();
    var rowcollection = table.$(".call-checkbox:checked", { "page": "all" });
    //selfme.selectedStopCardsList = [];
    rowcollection.each(function (index, elem) {      
      let selectedCard: StopCard = new StopCard();
      selectedCard.cardId = $(elem).val();
      selectedCard.cardNumber = $(elem).attr("data-cardNumber");
      selectedCard.reason = 'OTHER';
      selectedCard.requiresReplacement = false;      
      selfme.selectedStopCardsList.push(selectedCard);            
    });
    setTimeout(() => {
      this.afterSelectedStopCardsLoad();
      this.loaderService.display(false);
      $('#modal-stopcards').modal('show');    
    }, 100);    
   
  }

  afterSelectedStopCardsLoad() {
    $('#stopcardspopupdatatable').DataTable({
      //dom: "fltB<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
      dom: '<"top"i<"clear">>rt<"bottom"i<"clear">>',
      responsive: true,
      info: false,
      iDisplayLength: 10,
      ordering: false,
      fixedColumns: true
    });
  }

  onStopCards() {
    this.managedCardService.msgs = [];
    if (this.selectedStopCardsList.length > 0) {
      let stopCardModel: StopCardModel = new StopCardModel();
      stopCardModel.stopRequests = this.selectedStopCardsList;      
      this.managedCardService.stopCards(stopCardModel)
        .subscribe(
        (stopCardModelRes: StopCardModel) => {
          this.managedCardService.showSuccess("Card Stop Request", "Your request to stop your selected card/s has been sent.", true);
          var table1 = $('#stopcardsdatatable').DataTable();
          table1.destroy();
           
          this.loadStopCardsList();
          //$('#modal-stopcards').modal('toggle');

          //var table2 = $('#stopcardspopupdatatable').DataTable();
          //table2.destroy();

          this.selectedStopCardsList = [];

          //this.getSelectedStopCards();
          
        },
        (error: any) => {          
          this.managedCardService.showError("Card Stop Request problem", <any>error, true);
        }
        );
    }
    //this.managedCardService.showSuccess("Card Stop Request", "Your request to stop your selected card/s has been sent.");
    //$('#modal-stopcards').modal('toggle');  
  }
  ngOnDestroy() {
    // prevent memory leak when component destroyed
    let userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternalLocalhost")));
    if (userData == undefined) {
      userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternal")));
    }
    if (userData != undefined) {
      let UserId = userData.sub;
      this.managedCardService.ClearStopCardsMemory(UserId,"stopcards")
        .subscribe(
          (drawingAccounts: null) => {

          },
          (error: any) => {

          }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/managecards/managedcards.stopcards.component.ts